export default "__VITE_ASSET__Bb2_Pcfc__"